export const refundPolicyData = [{
    header: "",
    content: 
            <div>
                <b>Last Updated:</b> Jan 17, 2026
            </div>
}, {
    header: "",
    content: 
            <div>
                At <b>Easy Image to Text</b>, we strive to ensure our users have a smooth experience. Refunds are available under limited conditions as outlined below.
            </div>
}, {
    header: "Consent",
    content: 
            <div>
                By using Easy Image to Text, you agree to the terms outlined in this Refund Policy.
            </div>
}, {
    header: <>✅ When We Offer Refunds?</>,
    content: 
            <>
                <div>
                    We offer refunds only under the following conditions:
                </div>
                <div className="infoWCdiv">
                    <div>1) Payment succeeded but premium access not activated</div>
                    <ul>
                        <li>
                            Based on your preference, we will either manually upgrade your account or issue a refund after verifying the payment ID.
                        </li>
                    </ul>
                </div>
                <div className="infoWCdiv">
                    <div>2) Refund requested within 24 hours of purchase</div>
                    <ul>
                        <li>Applicable only if you have extracted not more than 10 images after upgrade.</li>
                    </ul>
                </div>
                <div className="infoWCdiv">
                    <div>3) Duplicate Payment</div>
                    <ul>
                        <li>If the same plan was purchased twice, we will verify and refund the duplicate payment.</li>
                    </ul>
                </div>
                <div className="infoWCdiv last">
                    <div>4) Chose the wrong plan?</div>
                    <ul>
                        <li>Contact us within 24 hours, <b>before</b> using the plan.</li>
                        <li>If <b>no usage</b> is detected, we can process a refund.</li>
                        <li>Refunds will <b>not</b> be issued if the plan has already been used.</li>
                    </ul>
                </div>
            </>
}, {
    header: <>❌ When Refunds Are Not Applicable?</>,
    content: 
            <>
                <div>
                    We do not offer refunds in the following scenarios:
                </div>
                <ul>
                    <li>Refund requested <b>after 24 hours</b> of payment.</li>
                    <li><b>More than 10 extractions</b> done after upgrade.</li>
                    <li><b>Abusive, fraudulent, or repeated</b> refund requests may be denied at our discretion. We reserve the right to suspend or block accounts involved in such misuse.</li>
                    <li>If sufficient <b>proof of payment (payment ID)</b> is not provided when requested.</li>
                </ul>
            </>
}, {
    header: "Refund Process",
    content: 
            <ul>
                <li>Approved refunds are processed within <b>5-7 business days</b>.</li>
                <li>Refunds are credited only via the <b>original payment method</b> (UPI/card/wallet)</li>
            </ul>
}, {
    header: "How to Request Refund / Report an Issue?",
    content: 
            <>
                <div>
                    Email us at 📧 <span className="emailId">support@easyimagetotext.com</span> with:
                    <ul>
                        <li><b>Payment ID</b> (required)</li>
                        <li>Phone number (optional)</li>
                    </ul>
                    This helps us locate your transaction quickly.
                </div>
            </>
}, {
    header: "Changes to This Policy",
    content: 
            <div>
                This policy may be updated periodically. Any changes will be reflected on this page with the updated date. The version available at the time of your payment will apply.
            </div>
}, {
    header: "Contact Us",
    content: 
            <div>
                If you have any questions regarding this Refund Policy, please contact us at:
                📧  <span className="emailId">support@easyimagetotext.com</span>
            </div>
}, {
    header: "",
    content: 
            <div>
                By using <b>Easy Image to Text</b>, you agree to the terms outlined in this Refund Policy.
            </div>
}]